import { TableCell, tableCellClasses } from '@mui/material';
import { styled } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

export const Container = styled('div', { name: 'AppDrawerContainer' })<{ fullHeight?: boolean }>(
  ({ fullHeight }) => ({
    display: 'flex',
    height: fullHeight ? '100%' : undefined,
    overflow: 'auto',
    position: 'relative',
  }),
);

export const Main = styled('div')(() => ({
  background: 'white',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
}));

export const MainFooter = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  padding: '24px',
  gap: '16px',
  height: '88px',
  backgroundColor: 'transparent',
  borderBottom: '1px solid #E4E7EC',
  fontFamily: 'Manrope',
  fontWeight: 700,
  fontSize: '22px',
  lineHeight: '28px',
  letterSpacing: '0%',
}));

export const MaiFooterSubmit = styled('div')(() => ({
  flex: 1,
  display: 'flex',
  justifyContent: 'flex-end',
}));

export const MainFooterSave = styled('button')(() => ({
  flex: 1,
  backgroundColor: '#0055A4',
  color: 'white',
  borderRadius: 8,
}));

export const MainTitle = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  padding: '24px',
  gap: '24px',
  height: '88px',
  backgroundColor: 'transparent',
  borderBottom: '1px solid #E4E7EC',
  fontFamily: 'Manrope',
  fontWeight: 700,
  fontSize: '22px',
  lineHeight: '28px',
  letterSpacing: '0%',
}));

export const MainTitleLabel = styled('div')(() => ({
  flex: 1,
  color: '#475467',
  fontFamily: 'Manrope',
  fontSize: '22px',
  fontWeight: 700,
  lineHeight: '28px',
}));

export const TableLabel = styled('div')(() => ({
  color: '#667085',
  fontFamily: 'Manrope',
  fontSize: '10px',
  fontWeight: 700,
  lineHeight: '15px',
  letterSpacing: '0.5px',
  textTransform: 'uppercase',
}));

export const MainContent = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '24px',
  overflowY: 'auto',
  backgroundColor: '#F9FAFB',
  flex: 1,
}));

export const GroupForm = styled('form')(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

const styles = makeStyles(() => ({
  gridWrapper: {
    '& .shipeezi-new-grid-component': {
      '& > div': {
        padding: '0px !important',
        margin: '0px !important',
      },
    },
    '& .MuiTableCell-head': {
      '& *': {
        padding: '0px !important',
        color: '#1D2939 !important',
      },
      padding: '8px 16px !important',
      gap: '12px',
      fontFamily: 'Manrope',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '16px',
      letterSpacing: ' 0.5px',
      alignSelf: 'stretch',
    },
    '& .MuiTableCell-body': {
      height: '64px',
      minHeight: '40px',
      maxHeight: '64px',
      padding: '0px 16px !important',
    },
  },
  inputLabel: {
    color: '#D92D20',
  },
  rowStyle: {
    color: '#475467',
    fontFamily: 'Manrope',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    letterSpacing: '0.4px',
  },
  label: {
    fontFamily: 'Manrope',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.1px',
    verticalAlign: 'middle',
    color: '#004D95',
    marginBottom: '4px',
  },
  labelDisabled: {
    fontFamily: 'Manrope',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.1px',
    verticalAlign: 'middle',
    color: '#98A2B3',
    marginBottom: '4px',
  },
  statusBadge: {
    borderRadius: 100,
    borderWidth: 1,
    gap: 8,
    background: '#FEE4E2 !important',
    border: '1px solid #E0E2E7',
    padding: '2px 8px',
    fontWeight: 700,
    fontSize: 11,
    lineHeight: '16px',
    color: '#F97066 !important',
    fontFamily: 'Manrope',
  },
  statusBadgeActive: {
    background: '#ECFDF3 !important',
    border: '1px solid #ECFDF3',
    color: '#027A48 !important',
  },
  statusBadgeInactive: {
    background: '#FEF3F2 !important',
    border: '1px solid #FEF3F2',
    color: '#B42318 !important',
  },
  groupInfo: {
    minHeight: '64px',
    maxHeight: 'fit-content',
    display: 'flex',
    background: '#E6EEF6',
    border: '1px solid #8AB1D5',
    borderRadius: '8px',
    padding: '12px',
  },
  groupInfoIcon: {
    fontSize: '20px',
    color: '#003C74',
  },
  groupInfoContent: {
    flex: 1,
    padding: '0 8px',
    color: '#003C74',
    lineHeight: '20px',
    letterSpacing: '0.25px',
    fontSize: '14px',
    fontWeight: 400,
    fontFamily: 'Manrope',
  },
  styledTableContrainer: {
    boxShadow: 'none',
    border: '1px solid #D0D5DD',
    borderRadius: '8px',
  },
  styledTableHead: {
    backgroundColor: '#FCFCFD',
    width: '96px',
  },
  styledTableCell: {
    fontFamily: 'Manrope',
    fontSize: 12,
    fontWeight: 700,
    color: '#1D2939',
    lineHeight: '16px',
    letterSpacing: '0.5px',
    borderRadius: '8px',
    verticalAlign: 'middle',
    padding: '8px 16px',
  },
  styledTableCellContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  btnClose: {
    fontFamily: 'Manrope',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.1px',
    textAlign: 'center',
    color: '#0055A4',
    textTransform: 'capitalize',
    height: '40px',
    gap: '8px',
    padding: '10px 12px',
  },
  btnSubmit: {
    cursor: 'pointer',
    textTransform: 'capitalize',
    height: '40px',
    gap: '8px',
    padding: '10px 20px',
    fontFamily: 'Manrope',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.1px',
    textAlign: 'center',
    borderRadius: '8px',
  },
  selectItem: {
    fontFamily: 'Manrope',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.25px',
    verticalAlign: 'middle',
    color: '#344054',
  },
  closeGroupDrawer: {
    cursor: 'pointer',
    width: '40px',
    height: '40px',
    padding: '8px',
    gap: '8px',
  },
  overlayLoading: {
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 1000,
  },
}));

export default styles;
